import {useQuery} from '@tanstack/react-query'
import {useContentstack} from '../../context/contentstack'
import {getEntry} from '../api/contentstack/sdk/entry'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {BRAND_KEY, BRAND_KEY_FILTER_CS} from '../../brand'

let prefix = ''
if (BRAND_KEY === 'kenwood' || BRAND_KEY === 'braun') prefix = `${BRAND_KEY}_`

export const useGetPageByType = (contentTypeUid, options = {}) => {
    const {stack} = useContentstack()
    const {locale} = useMultiSite()

    const getMainMenu = async () => {
        const response = await getEntry({
            stack,
            contentTypeUid: `${prefix}${contentTypeUid}`,
            locale: locale.alias,
            brand: BRAND_KEY_FILTER_CS,
        })
        return response && response[0] ? response[0] : null
    }

    const query = useQuery([contentTypeUid], () => getMainMenu(), options)

    return query
}
